const convertStreamToText = async (body: BodyInit): Promise<string> => {
  try {
    return new Response(body).text();
  } catch (e) {
    return Promise.reject("Unable to convert stream to text");
  }
};

export default convertStreamToText;
